import Joi from 'joi';

import { requiredBoolean, requiredString } from '../../../utils/validators';
import { FormValues } from './types';

export const validationSchema = Joi.object<FormValues, true>({
  selectedCourseId: requiredString,
  pinSelectedCourse: requiredBoolean,
});
